"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react")),
    _uiKit = require("@devsta/ui-kit");

require("../styles/_duration-dropdown.scss");

function Duration(a) {
  var b = a.duration,
      c = a.onChangeAddon,
      d = a.DURATIONS,
      e = a.disabled;
  return _react["default"].createElement("div", {
    className: "duration-dropdown"
  }, _react["default"].createElement(_uiKit.Dropdown, {
    options: d,
    value: b ? d && d.find(function (a) {
      return a.value === b;
    }) || null : null,
    label: "Longform Edit",
    labelProps: {
      divContainer: !0,
      extraLabelContent: !e && b && _react["default"].createElement(_uiKit.Button, {
        type: "TERTIARY",
        prefix: "trash",
        onClick: function onClick() {
          c("DURATION")(null);
        }
      })
    },
    onChange: c("DURATION"),
    showSelectedSuffix: !0,
    disabled: e,
    type: "BUTTON",
    placeholder: "Select a longform edit"
  }));
}

var _default = (0, _react.memo)(Duration);

exports["default"] = _default;